import React from 'react'

import { Panel } from 'rsuite'

interface LabelPreview {
  data: {
    system_name: string
    name: string
    description: string
    image?: {
      url?: string
    }
    optionColor: string
    optionBackgroundColor: string
    optionLink: string
    optionLinkLabel: string
  }
}

import './LabelPreview.scss'

export default function LabelPreview ({ data }: LabelPreview) {
  return (
    <Panel shaded>
      {data && (
        <div className="LabelPreview">
          {data.image && (
            <div
              style={{
                backgroundImage: 'url(' + data.image.url + ')'
              }}
              className="LabelPreview__Chevron"
            />
          )}
          {data.name ? (
            <h2 className="LabelPreview__Head">{data.name}</h2>
          ) : (
            <h2 className="LabelPreview__Head">{data.system_name}</h2>
          )}
          {data.description && (
            <div className="LabelPreview__Description">{data.description}</div>
          )}
          {data.optionLink && (
            <div className="LabelPreview__Link">
              <a href={data.optionLink}>{data.optionLinkLabel}</a>
            </div>
          )}
        </div>
      )}
    </Panel>
  )
}
